import Axios from 'api/client';

interface S3SignedUrlResponse {
    url: string;
}

const getSignedUrl = () =>
    Axios.post<S3SignedUrlResponse>(`/s3_upload`).then(response => response.data);

const uploadToS3 = (url: string, file: File) =>
    Axios.put(url, file, {
        withCredentials: false,
        transformRequest: (data, headers) => {
            if (headers['Authorization']) {
                delete headers['Authorization'];
            }
            return data;
        },
        headers: {
            'Content-Type': file.type,
        },
    });

export { getSignedUrl, uploadToS3 };
